<template>
    <jet-confirmation-modal :show="show || triggerModal" @close="handleClose">
        <template #title>
            Discard Unsaved Changes?
        </template>

        <template #content>
            <p>This page has changes that have not been saved.</p>
            <p>Would you like to continue and <span class="font-bold">discard these changes?</span></p>
        </template>

        <template #footer>
            <jet-tertiary-button @click="handleClose">
                No
            </jet-tertiary-button>

            <jet-danger-button class="ml-2" @click="handleConfirm">
                Yes
            </jet-danger-button>
        </template>
    </jet-confirmation-modal>
</template>

<script>
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';

export default {

    components: {
        JetConfirmationModal,
        JetDangerButton,
        JetTertiaryButton,
    },

    props: ['show', 'formRoute', 'isDirty', 'ignoreRoutes'],

    emits: ['confirm', 'close'],

    data() {
        return {
            visit: null,
            triggerModal: false,
            hasChanges: false,
            removeListener: null,
        }
    },

    methods: {
        handleClose() {
            this.visit = null;
            this.triggerModal = false;
            this.$emit('close');
        },

        handleConfirm() {
            if(this.visit == null) {
                // Trigger the event to get the URL set
                this.$emit('confirm');
                return;
            }

            // Override the changes to bypass the listener
            this.hasChanges = false;

            let url = this.visit.url;
            let method = this.visit.method;
            let data = this.visit.data;

            this.$inertia.visit(url, { method: method, data: data });
        },
    },

    watch: {
        isDirty: {
            handler(newVal) {
                this.hasChanges = newVal;
            },
            immediate: true
        },
    },

    created() {
        this.removeListener = this.$inertia.on('before', event => {
            // Ignore submission of parent form/any routes in ignoreRoutes prop
            const urlNoQuery = event.detail.visit.url.href.split('?')[0]
            const ignore = [this.formRoute, ...(this.ignoreRoutes || [])].filter(Boolean)
            if (ignore.includes(urlNoQuery)) return true

            this.visit = event.detail.visit;

            if(this.hasChanges) {
                // Manual trigger for modal when intercepting other navigation
                this.triggerModal = true;
                return false;
            }

            return true;
        });
    },

    unmounted() {
        this.removeListener();
    },
}
</script>

<style>

</style>